import { useId, useState } from "react";

import avatarImage from "@/assets/images/avatar.svg";

import { formatPhoneNumber } from "../../../../Utils/helper";

import "./property-damage-insurance-tab.css";

const getInsuredEntity = (insurance) => {
  const entity = insurance.entity_obj || {};
  const fullName = [entity.first_name, entity.last_name].filter(Boolean).join(" ").trim();
  const type = String(insurance.entity_type || "").toLowerCase();

  switch (type) {
    case "defendant":
      return {
        icon: "ic-defendants",
        type: "Defendant",
        name:
          Number(entity.defendantType?.id) === 1
            ? fullName || insurance.entity_name || ""
            : entity.entity_name || insurance.entity_name || "",
        subtype: entity.defendantType?.name,
      };
    case "client":
      return {
        icon: "ic-client",
        profilePic: entity.profile_pic_29p || entity.profile_pic,
        type: "Client",
        name: fullName || insurance.entity_name || "",
      };
    case "otherparty":
      return {
        icon: "ic-parties",
        type: "Other Party",
        name:
          [entity.party_first_name, entity.party_last_name].filter(Boolean).join(" ") ||
          insurance.entity_name ||
          "",
      };
    default:
      return {
        type: insurance.entity_type || "Entity",
        name: insurance.entity_name || entity.entity_name || fullName || "",
      };
  }
};

const InsuredEntityIcon = ({ entity }) => {
  const [failedPhoto, setFailedPhoto] = useState(null);

  if (entity.profilePic && entity.profilePic !== failedPhoto) {
    return (
      <img
        className="property-damage-insurance-client-photo"
        src={entity.profilePic ?? avatarImage}
        alt=""
        style={{
          background: "var(--primary-30)",
        }}
        aria-hidden="true"
        onError={() => setFailedPhoto(entity.profilePic)}
      />
    );
  }

  return entity.icon ? <i className={`ic ic-15 ${entity.icon}`} aria-hidden="true" /> : null;
};

const PropertyDamageInsuranceTab = ({ insurances = [], selectedInsurance, onSelect }) => {
  const idPrefix = useId();

  return (
    <div className="property-damage-insurance-options">
      <div className="text-grey m-b-5">Insurance Responsible</div>
      <div
        className="property-damage-insurance-list"
        role="radiogroup"
        aria-label="Insurance Responsible"
      >
        {insurances.map((insurance) => {
          const entity = getInsuredEntity(insurance);
          const adjuster = insurance.adjuster || {};
          const directoryAdjuster = insurance.adjuster_ID?.contact || {};
          const adjusterName =
            [
              adjuster.first_name ||
                directoryAdjuster.first_name ||
                insurance.adjuster_ID?.first_name,
              adjuster.last_name || directoryAdjuster.last_name || insurance.adjuster_ID?.last_name,
            ]
              .filter(Boolean)
              .join(" ") ||
            adjuster.name ||
            directoryAdjuster.name ||
            "";
          const adjusterPhone = adjuster.phone_number || directoryAdjuster.phone_number;
          const phoneExtension = adjuster.phone_ext || directoryAdjuster.phone_ext;
          const companyName =
            insurance.company_contact?.name || insurance.company?.company_name || "";
          const insuranceType = insurance.insurance_type?.name || "";
          const policyNumber = String(insurance.policy_number ?? "").trim();
          const claimNumber = String(insurance.claim_number ?? "").trim();
          const optionLabel = [
            companyName,
            insuranceType,
            entity.name ? `${entity.type}: ${entity.name}` : "",
          ]
            .filter(Boolean)
            .join(", ");
          const optionId = `${idPrefix}-${insurance.id}`;
          const isSelected = String(selectedInsurance) === String(insurance.id);

          return (
            <label
              key={insurance.id}
              htmlFor={optionId}
              className={`property-damage-insurance-row ${isSelected ? "selected" : ""}`}
            >
              <input
                type="radio"
                className="form-check mb-0"
                name={`${idPrefix}-insuranceResponsible`}
                id={optionId}
                checked={isSelected}
                onChange={() => onSelect(insurance.id)}
                aria-label={optionLabel ? `Select ${optionLabel}` : "Select insurance policy"}
              />
              {policyNumber && <span>{policyNumber}</span>}
              {claimNumber && <span>{claimNumber}</span>}
              {adjusterName.trim() && <span>{adjusterName}</span>}
              {adjusterPhone && (
                <span>
                  {formatPhoneNumber(adjusterPhone)}
                  {phoneExtension ? ` ext. ${phoneExtension}` : ""}
                </span>
              )}
              {entity.name.trim() && (
                <span className="property-damage-insurance-entity">
                  <InsuredEntityIcon entity={entity} />
                  <span>{entity.name}</span>
                </span>
              )}
              {companyName.trim() && (
                <span>
                  <strong>{companyName}</strong>
                </span>
              )}
              {insuranceType.trim() && <span>{insuranceType}</span>}
            </label>
          );
        })}
        {!insurances.length && (
          <div className="text-grey">No insurance policies added to this case.</div>
        )}
      </div>
    </div>
  );
};

export default PropertyDamageInsuranceTab;
